import React, { useEffect, useState } from "react";
import "./tailwind.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import AboutUs from "./components/AboutUs";
import Services from "./components/Services";
// import FocusCards from "./components/FocusCards";
import Contact from "./components/Contact";
import FadeOnScroll from "./components/FadeOnScroll";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import FAQ from "./components/FAQ";
import OurProcess from "./components/OurProcess";

// Importing individual service pages
import Websites from "./components/services/Websites";
import Software from "./components/services/Software";
import Maintenance from "./components/services/Maintenance"; 

function App() {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    const savedMode = localStorage.getItem("dark-mode") === "true";
    setDarkMode(savedMode);
    if (savedMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, []);

  const toggleDarkMode = () => {
    const newMode = !darkMode;
    setDarkMode(newMode);
    localStorage.setItem("dark-mode", newMode);
    if (newMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  };

  // const interestCards = [
  //   { title: "Producing tracks on Logic Pro", src: "/assets/logicpropic.png" },
  //   { title: "Dining Out", src: "/assets/food.png" },
  //   { title: "Travelling", src: "/assets/travel.png" },
  //   { title: "Painting", src: "/assets/pot.png" },
  //   { title: "Collecting Retro Shirts", src: "/assets/shirt.jpeg" },
  //   { title: "Football at Wembley", src: "/assets/wembley.jpeg" },
  // ];

  return (
    <Router>
      <div className={`relative min-h-screen ${darkMode ? "bg-dark-static text-white" : "bg-light-gradient text-black"}`}>
        <Header toggleDarkMode={toggleDarkMode} darkMode={darkMode} />

        <Routes>
          <Route path="/" element={
            <main className="space-y-60">
              <Hero darkMode={darkMode} />
              <FadeOnScroll><AboutUs /></FadeOnScroll>
              <FadeOnScroll><Services /></FadeOnScroll>
              {/* <FadeOnScroll><FocusCards cards={interestCards} /></FadeOnScroll> */}
              {/* <FadeOnScroll><Contact /></FadeOnScroll> */}
            </main>
          } />

          {/* Individual pages */}
          <Route path="/services/websites" element={<Websites />} />
          <Route path="/services/software" element={<Software />} />
          <Route path="/services/maintenance" element={<Maintenance />} />
          <Route path="/faq" element={<FAQ darkMode={darkMode} />} />
          <Route path="/our-process" element={<OurProcess darkMode={darkMode} />} />
          <Route path="/contact" element={<Contact darkMode={darkMode} />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default App;